module.exports = __webpack_public_path__ + "img/check.5ea11e11.png";